<template>
<div>
  <form role="form" class="elr-form elr-container" @submit.prevent="update" id="update-manufacturer">
    <ul v-show="errors.length">
      <li :key="e" v-for="e in errors">
        <span :key="value" v-for="(key, value) in e">{{value}}: {{key[0]}}</span>
      </li>
    </ul>
    <div class="elr-row">
      <div class="elr-col-full">
        <input type="text" placeholder="Manufacturer Name" name="name" v-model="formData.name">
      </div>
    </div>
    <div class="elr-row">
      <div class="elr-col-full">
        <textarea cols="30" rows="10" name="description" v-model="formData.description" placeholder="Description"></textarea>
      </div>
    </div>
    <div class="elr-row">
      <div class="elr-col-full form-input-holder">
        <button type="submit" class="elr-button elr-button-primary">Update Manufacturer</button>
      </div>
    </div>
  </form>
</div>
</template>

<script>
export default {
  name: 'FormManufacturerEdit',
  props: {
    id: {
      type: String,
      required: true
    },
    manufacturer: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      errors: [],
      formData: {
        name: null,
        description: null
      }
    };
  },
  mounted() {
    this.formData = Object.assign({}, this.manufacturer);
  },
  methods: {
    update() {
      this.$store.dispatch('manufacturer/UPDATE', this.formData);
    }
  }
};
</script>
